import React, { Fragment, useEffect, useRef } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import {
  // getAndRegisterFcmToken,
  onMessageListener,
  requestNotificationPermission,
} from 'firebaseMessaging'
import { message } from 'antd'
import { CheckCircleFilled } from '@ant-design/icons'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
}

const mapStateToProps = ({ user, settings }) => ({ user, title: settings.logo })
let previousPath = ''

const Layout = ({ user, children, title, location: { pathname, search } }) => {
  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  const effectRan = useRef(false)

  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    previousPath = currentPath
  }, 300)

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth'
    }
    return 'main'
  }

  // useEffect(() => {
  //   // Request FCM token
  //   requestNotificationPermission().then((token) => {
  //     if (token) console.log('User FCM Token:', token)
  //   })

  //   // Subscribe to foreground messages continuously
  //   const unsubscribe = onMessageListener((payload) => {
  //     console.log('📩 Foreground message received:', payload)
  //     new Notification(payload.title, {
  //       body: payload.body,
  //       icon: payload.icon || '/firebase-logo.png',
  //     })

  //     if (payload) {
  //       // const cleanTitle = removeEmojis(payload.title)
  //       // const cleanBody = removeEmojis(payload.body)

  //       // message.success({
  //       //   content: (
  //       //     <div>
  //       //       <div style={{ display: 'flex', alignItems: 'center', fontSize: 16, fontWeight: 600 }}>
  //       //         <CheckCircleFilled style={{ color: 'green', marginRight: 8 }} />
  //       //         {payload.notification.title}
  //       //       </div>
  //       //       <div style={{ fontSize: 14, marginTop: 4 }}>{payload.notification.body}</div>
  //       //     </div>
  //       //   ),
  //       //   duration: 5,
  //       // })
  //       message.open({
  //         type: 'success',
  //         icon: null, // 🚫 remove AntD’s default icon
  //         content: (
  //           <div>
  //             <div style={{ display: 'flex', alignItems: 'center', fontSize: 16, fontWeight: 600 }}>
  //               <CheckCircleFilled style={{ color: 'green', marginRight: 8 }} />
  //               {payload.title}
  //             </div>
  //             <div style={{ fontSize: 14, marginTop: 4 }}>{payload.body}</div>
  //           </div>
  //         ),
  //         duration: 5,
  //       })
  //     }
  //   })

  //   // Cleanup on unmount
  //   return () => {
  //     if (unsubscribe) unsubscribe()
  //   }
  // }, [])
  useEffect(() => {
    if (effectRan.current) return
    effectRan.current = true

    const initNotifications = async () => {
      const token = await requestNotificationPermission()
      if (token) console.log('User FCM Token:', token)

      // Foreground listener
      const unsubscribe = onMessageListener((payload) => {
        message.open({
          icon: null,
          content: (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', fontSize: 16, fontWeight: 600 }}>
                <CheckCircleFilled style={{ color: 'green', marginRight: 8 }} />
                {payload.title}
              </div>
              <div style={{ fontSize: 14, marginTop: 4 }}>{payload.body}</div>
            </div>
          ),
          duration: 5,
        })
      })

      return () => unsubscribe && unsubscribe()
    }

    initNotifications()
  }, [])

  const Container = Layouts[getLayout()]
  const isUserAuthorized = user.authorized
  const isUserLoading = user.loading
  const isAuthLayout = getLayout() === 'auth'

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null
    }
    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized) {
      return <Redirect to={{ pathname: '/auth/login', state: { from: pathname + search } }} />
    }
    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      <Helmet titleTemplate={`${title} | %s`} title={title} />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default withRouter(connect(mapStateToProps)(Layout))
